import { BookMark } from "../Icons/Icon";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/get";
import { addBookmark, deleteBookmark, getBookmarks } from "../../../api/utils";
import SignInPopUpModal from "../cards/SignInPopUPModal";
import { BOOKMARK_DATA } from "../../../isomorphic/components/store/actions";
import React from "react";
const BookmarkIcon = ({ story }) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => get(state, ["firebaseUser"], null));
  const bookmarksData = useSelector((state) => get(state, ["bookmarkData"], null));

  const { bookmarkIds, bookmarks } = bookmarksData !== null ? bookmarksData[0] : { bookmarkIds: [], bookmarks: [] };
  const getBookmarksData = async (user) => {
    if (!user) return;
    try {
      if (!user) return;
      const bookmarks = await getBookmarks(user?.email, 0);
      dispatch({
        type: BOOKMARK_DATA,
        bookmarkData: { bookmarks: bookmarks, bookmarkIds: bookmarks.map((item) => item.storyId) },
      });
    } catch (error) {
      console.error("Error fetching bookmarks:", error);
    }
  };
  const AddBookmark = async (story, user) => {
    if (!user) return;
    if (bookmarkIds.includes(story["story-id"])) return;

    let data = {
      email: user.email,
      storyId: story.id,
      headline: story.headline,
      authorName: story["author-name"],
      type: "article",
      section: story.sections[0].name,
      slug: story.slug,
      storyUrl: story.url,
      imageSlug: story["hero-image-s3-key"],
    };
    await addBookmark(data);
    getBookmarksData(user);
  };

  const RemoveBookmark = async (story, user) => {
    if (!user) return;
    // console.log(bookmarks);
    let id = bookmarks.filter((item) => item.storyId === story.id)[0].id;
    // console.log(id);
    await deleteBookmark(user.email, id);
    getBookmarksData(user);
  };

  return (
    <>
      {!user ? (
        <SignInPopUpModal />
      ) : bookmarkIds.includes(story.id) ? (
        <button className="cursor-pointer" onClick={() => RemoveBookmark(story, user)}>
          <BookMark fill={true} />
        </button>
      ) : (
        <button className="cursor-pointer" onClick={() => AddBookmark(story, user)}>
          <BookMark fill={false} />
        </button>
      )}
    </>
  );
};

export default BookmarkIcon;
